export default __webpack_public_path__ + "static/media/property_616.eeeca6ed.png";